import React, { useEffect, useState } from "react";

export default function AdminIDERequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/admin/ide/requests", { credentials: "include" })
      .then((res) => res.json())
      .then((data) => setRequests(data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const approveRequest = async (id) => {
    const res = await fetch(`/admin/ide/approve/${id}`, {
      method: "POST",
      credentials: "include",
    });
    console.log("RES======",res);
    if (res.ok) {
      setRequests((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, status: "approved" } : r
        )
      );

      // fetch("/api/rosbridge/start", {
      //   method: "POST",
      //   credentials: "include",
      // }).catch(err => {
      //   console.error("Failed to start rosbridge", err);
      // });
    }
  };


  const disapproveRequest = async (id) => {
    const res = await fetch(`/admin/ide/disapprove/${id}`, {
      method: "POST",
      credentials: "include",
    });

    if (res.ok) {
      setRequests((prev) =>
        prev.map((r) =>
          r.id === id ? { ...r, status: "rejected" } : r
        )
      );
    }
  };

  if (loading) return <div className="container mt-4">Loading...</div>;

  return (
    <div className="container mt-4">
      <h3>IDE Requests</h3>

      {requests.length === 0 ? (
        <p>No requests found.</p>
      ) : (
        <table className="table table-striped align-middle">
          <thead>
            <tr>
              <th>User ID</th>
              <th>User Name</th>
              <th>Requested At</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {requests.map((req) => (
              <tr key={req.id}>
                <td>{req.user_id}</td>
                <td>{req.user_name}</td>
                <td>{new Date(req.requested_at).toLocaleString()}</td>
                <td>
                  {req.status === "approved" && (
                    <span className="badge bg-success">Approved</span>
                  )}
                  {req.status === "rejected" && (
                    <span className="badge bg-danger">Rejected</span>
                  )}
                  {req.status === "pending" && (
                    <span className="badge bg-secondary">Pending</span>
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-success btn-sm me-2"
                    disabled={req.status === "approved"}
                    onClick={() => approveRequest(req.id)}
                  >
                    Approve
                  </button>

                  <button
                    className="btn btn-danger btn-sm"
                    disabled={req.status !== "approved"}
                    onClick={() => disapproveRequest(req.id)}
                  >
                    Disapprove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
